// Utility function to fetch data with AJAX
async function fetchCartData(url, method = "GET", bodyData = null) {
  const options = {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  if (bodyData) options.body = JSON.stringify(bodyData);

  const response = await fetch(url, options);
  return await response.json();
}

// ==========================
// Flags for upsell add state
// ==========================
window.addingFromUpsell = false;     // signals we clicked an upsell add button
window.upsellToPrune = null;         // { variantId, productId } of item to prune from upsell UI

function markUpsellAddStart(variantId, productId) {
  window.addingFromUpsell = true;
  window.upsellToPrune = {
    variantId: String(variantId || ''),
    productId: String(productId || '')
  };
}

// Remove the just-added upsell card(s) from the preserved upsell DOM
function pruneAddedUpsellFromDOM() {
  if (!window.upsellToPrune) return;

  const { variantId, productId } = window.upsellToPrune;

  // Build selectors that cover common markup patterns
  const selParts = [];
  if (variantId) {
    selParts.push(
      `.upsell-carousel-item[data-variant-id="${variantId}"]`,
      `.upsell-carousel-item [data-variant-id="${variantId}"]`
    );
  }
  if (productId) {
    selParts.push(
      `.upsell-carousel-item[data-product-id="${productId}"]`,
      `.upsell-carousel-item [data-product-id="${productId}"]`
    );
  }
  const sel = selParts.join(',');

  if (sel) {
    document.querySelectorAll(sel).forEach(n => {
      const card = n.closest('.upsell-carousel-item') || n;
      if (card && card.parentElement) card.parentElement.removeChild(card);
    });
  }

  if (typeof onUpsellItemsChanged === 'function') onUpsellItemsChanged();

  window.addingFromUpsell = false;
  window.upsellToPrune = null;
}

// Open Cart Drawer Function
function openCartDrawer() {
  const cartDrawer = document.querySelector(".f-cart-drawer");
  cartDrawer.classList.add("f-cart-drawer--active");
  variantSelection();

  var elements = $('.f-cart-drawer-item .frog_main'); 
  if(elements.length > 0){
    $('.f-cart-drawer-item .frog_main:first').removeClass('hidden');
  }
  
}

// Close Cart Drawer Function
function closeCartDrawer() {
  document.querySelector(".f-cart-drawer").classList.remove("f-cart-drawer--active");
}

// Update Cart Item Count Function
async function updateCartItemCount(count = 0) {
  const cart = await fetchCartData('/cart.js');
  const itemCount = count !== 0 ? count : cart.item_count;
  document.querySelectorAll('.cart-count-bubble').forEach(el => {
    el.textContent = itemCount;
    el.classList.toggle('empty_cart', itemCount <= 0);
  });
}

// Update Cart Drawer Function
async function updateCartDrawer() {
  try {
    const res = await fetch('/?section_id=unit-drawer');
    const html = document.createElement("div");
    html.innerHTML = await res.text();

    const newDrawerContent = html.querySelector(".f-cart-drawer");
    if (newDrawerContent) {
      const cartDrawer = document.querySelector('.f-cart-drawer');
      if (cartDrawer) {
        // If adding from upsell, preserve the upsell section
        if (window.addingFromUpsell) {
          const existingUpsellSection = cartDrawer.querySelector('.upsell-carousel-section');
          
          // Replace cart content but keep upsell section
          cartDrawer.innerHTML = newDrawerContent.innerHTML;
          
          // Restore the preserved upsell section
          if (existingUpsellSection) {
            const newUpsellSection = cartDrawer.querySelector('.upsell-carousel-section');
            if (newUpsellSection) {
              newUpsellSection.replaceWith(existingUpsellSection);
            }
          }
        } else {
          // Normal update - replace everything
          cartDrawer.innerHTML = newDrawerContent.innerHTML;
        }
      }
    } else {
      console.error("Error: Unable to find the '.f-cart-drawer' element in the fetched content.");
    }

    // Re-attach event listeners after updating the cart drawer content
    addCartDrawerListeners();
    removeCartDrawerListeners();
    addCartUpsellListeners();
    addCartUpsellListeners2();
    variantSelection();
    
    // Initialize the carousel only if not adding from upsell
    if (typeof initCarousel === 'function' && !window.addingFromUpsell) {
      initCarousel();
    }

    // ... rest of the function stays the same
    const cartData = await fetch('/cart.js').then(response => response.json());
    const itemsCount = cartData.item_count;
    const shippingProtectionCheckbox = document.querySelector('#shippingProtection');

    if (shippingProtectionCheckbox && !manualCheckboxToggle) {
      if (itemsCount > 0 && !shippingProtectionCheckbox.checked) {
        if (!sessionStorage.getItem('shippingProtectionClicked')) {
          shippingProtectionCheckbox.click();
          sessionStorage.setItem('shippingProtectionClicked', 'true');
        }
      } else if (itemsCount <= 1 && shippingProtectionCheckbox.checked) {
        shippingProtectionCheckbox.click();
      }
    }
    
    var elements = $('.f-cart-drawer-item .frog_main'); 
    if(elements.length > 0){
      $('.f-cart-drawer-item .frog_main:first').removeClass('hidden');
    }

    if($('#StickySubtotal').length > 0){
      if($('.f-cart-drawer-button').length > 0){
        var carttot = $('.f-cart-drawer-button').text().split('Checkout •')[1];
        $('#StickySubtotal').text(carttot);
        $('#StickySubmit').removeAttr('disabled');
      }else{
        var defprc = $('#StickySubtotal').attr('data-attr');
        $('#StickySubtotal').text(defprc);
        $('#StickySubmit').attr('disabled',true);
      }

      if (itemsCount == 1 ){
        $('#StickyItems').text(itemsCount+' item');
      }else {
        $('#StickyItems').text(itemsCount+' items');
      }

      if (itemsCount > 0 ){
        $('#StickyCart').addClass('active');
        $('.mob-thumb-menu-cstm-cls').addClass('hidden');
      }else{
        $('#StickyCart').removeClass('active');
        $('.mob-thumb-menu-cstm-cls').removeClass('hidden');
      }
    }

    // Final defensive prune in case of races
    if (window.addingFromUpsell && window.upsellToPrune) {
      pruneAddedUpsellFromDOM();
    }
    
  } catch (error) {
    console.error("Failed to update cart drawer:", error);
  }
}

// Add Event Listeners for Cart Drawer
function addCartDrawerListeners() {
  
  document.querySelectorAll('.f-cart-drawer-quantity-selector:not(.mainFound) button').forEach(button => {
    button.addEventListener("click", async () => {
      button.querySelector('.icon').classList.add('hidden');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const rootItem = button.closest('[data-line-item-key]');
      const key = rootItem.getAttribute("data-line-item-key");
      const currentQuantity = Number(button.parentElement.querySelector('input').value);
      const isUp = button.classList.contains('f-cart-drawer-quantity-selector-plus');
      const newQuantity = isUp ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);

      const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: newQuantity } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();

      button.querySelector('.icon').classList.remove('hidden');
      button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  });

  document.querySelectorAll('.f-cart-drawer-quantity-selector.mainFound button').forEach(button => {
    button.addEventListener("click", async () => {
      button.querySelector('.icon').classList.add('hidden');
      button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      let lineItemkeyArray = [];
      const rootItem = button.closest('[data-line-item-key]');
      const parentItemID = rootItem.getAttribute("data-main-id");
      const parentItemProperty = rootItem.getAttribute("data-property");
      const key = rootItem.getAttribute("data-line-item-key");
      const currentQuantity = Number(button.parentElement.querySelector('input').value);
      const isUp = button.classList.contains('f-cart-drawer-quantity-selector-plus');
      const newQuantity = isUp ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);

      lineItemkeyArray.push(key);

      let itemsBundle = document.querySelectorAll(`.bundle_item[data-bundle-id="${parentItemID}"]`);

        itemsBundle.forEach(function(item_input) {
          let itemKey = item_input.getAttribute("data-line-item-key");
          let itemPropertyData = item_input.getAttribute("data-property");
          if (itemPropertyData == parentItemProperty) {
            if (newQuantity != item_input.value) {
              item_input.value = newQuantity;
              if (!lineItemkeyArray.includes(itemKey)) {
                  lineItemkeyArray.push(itemKey);
              }         
            }         
      
          }        
      });
       // Function to check if an object is empty
         function isObjectEmpty(obj) {
            return Object.keys(obj).length === 0;
        }
        
        // Function to update cart
        async function updateCartCustom(lineItemsToUpdate) {
            if (isObjectEmpty(lineItemsToUpdate)) {
                console.log('No updates to make.');
                return; // Exit the function if there are no updates
            }
        
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        updates: lineItemsToUpdate
                    })
                });
        
                const data = await response.json();
                console.log('Cart updated:', data);
        
                await updateCartItemCount(); // Await other async functions
                await updateCartDrawer();
            } catch (error) {
                console.error('Error:', error);
            }
        }

        
        // Prepare line items for update
        let updates = {};
        lineItemkeyArray.forEach(itemKey => {
            updates[itemKey] = newQuantity; 
        });
        
        // Update the cart
       await updateCartCustom(updates);

      // const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: newQuantity } });

      button.querySelector('.icon').classList.remove('hidden');
      button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  });
  

  document.querySelector(".f-cart-drawer-box").addEventListener("click", (e) => e.stopPropagation());

  document.querySelectorAll(".f-cart-drawer-header-right-close, .f-cart-drawer").forEach(el => {
    el.addEventListener("click", closeCartDrawer);
  });
  
}

// Remove Cart Item Function
function removeCartDrawerListeners() {
  document.querySelectorAll('.f-cart-drawer-item-main-flex-right:not(.mainFound) button').forEach(button => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();
      const rootItem = button.closest('[data-line-item-key]');
      const key = rootItem.getAttribute("data-line-item-key");

      const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 0 } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer();
    });
  });

  document.querySelectorAll('.f-cart-drawer-item-main-flex-right.mainFound button').forEach(button => {
    button.addEventListener("click", async (e) => {
        e.preventDefault();
        
        const rootItem = button.closest('[data-line-item-key]');
        if (!rootItem) return;

        const key = rootItem.getAttribute("data-line-item-key");
        const parentItemID = rootItem.getAttribute("data-main-id");
        const parentItemProperty = rootItem.getAttribute("data-property");

        let lineItemkeyArray = [key];
        let newQuantity = 0;

        // Find all bundle items with the same parent ID
        let itemsBundle = document.querySelectorAll(`.bundle_item[data-bundle-id="${parentItemID}"]`);
        
        itemsBundle.forEach(item => {
            let itemKey = item.getAttribute("data-line-item-key");
            let itemPropertyData = item.getAttribute("data-property");

            if (itemPropertyData === parentItemProperty && !lineItemkeyArray.includes(itemKey)) {
                lineItemkeyArray.push(itemKey);
            }
        });

        // Function to check if an object is empty
        function isObjectEmpty(obj) {
            return Object.keys(obj).length === 0;
        }

        // Function to update cart
        async function updateCartCustom(lineItemsToUpdate) {
            if (isObjectEmpty(lineItemsToUpdate)) {
                console.log('No updates to make.');
                return;
            }

            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: lineItemsToUpdate })
                });

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const data = await response.json();
                console.log('Cart updated:', data);

                await updateCartItemCount();
                await updateCartDrawer();
            } catch (error) {
                console.error('Cart update failed:', error);
            }
        }

        // Prepare updates
        let updates = {};
        lineItemkeyArray.forEach(itemKey => {
            updates[itemKey] = newQuantity;
        });

        // Ensure items are fully removed
        if (Object.keys(updates).length > 0) {
            await updateCartCustom(updates);
        }
    });
});
}

// Add Upsell Listeners
function addCartUpsellListeners() {
  document.querySelectorAll('.add.f-upsale-add, .upsell-add-btn').forEach(button => {
    if (button.__upsellBound) return; // prevent double-binding after re-renders
    button.__upsellBound = true;

    // ==========================
    // FIX: remove any inline onclick to avoid double-add
    // ==========================
    if (button.hasAttribute('onclick')) {
      button.removeAttribute('onclick');
    }

    button.addEventListener("click", async (e) => {
      // Hard stop any legacy listeners bubbling up
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      const variantId = button.getAttribute("data-variant-id");
      const productId = button.getAttribute("data-product-id"); // optional
      if (!variantId) return;

      // mark as upsell add so updateCartDrawer preserves the upsell section
      markUpsellAddStart(variantId, productId);

      const label = button.querySelector('span');
      const spinner = button.querySelector('.loading-overlay__spinner');
      if (label) label.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');

      // Use update.js with explicit quantity 1 (from 0 -> 1)
      const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [variantId]: 1 } });
      await updateCartItemCount(cart.item_count);
      await updateCartDrawer(); // upsell section preserved here

      // remove the just-added card from the preserved upsell DOM
      pruneAddedUpsellFromDOM();

      if (label) label.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    });
  });
}

// Global variable to track manual clicks
let manualCheckboxToggle = false;

// Function to handle manual checkbox clicks (from addCartUpsellListeners2)
function addCartUpsellListeners2() {
  document.querySelectorAll('#shippingProtection').forEach(button => {
    if (button.__shipProtBound) return;
    button.__shipProtBound = true;

    button.addEventListener("change", async (e) => {
      const key = 46565880922344; // Variant ID

      // Set manual checkbox toggle flag to true when the user manually changes the checkbox
      manualCheckboxToggle = true;

      // Check if the checkbox is checked
      if (e.target.checked) {
        // If checked, add the variant (quantity = 1)
        const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 1 } });
        await updateCartItemCount(cart.item_count);
        await updateCartDrawer();
      } else {
        // If unchecked, remove the variant (quantity = 0)
        const cart = await fetchCartData('/cart/update.js', 'POST', { updates: { [key]: 0 } });
        await updateCartItemCount(cart.item_count);
        await updateCartDrawer();
      }

      // Reset the manual toggle flag after processing the click
      manualCheckboxToggle = false;
    });
  });
}

// Variant Selection Function
function variantSelection() {
  document.querySelectorAll('.f-upsale-main select').forEach(select => {
    select.addEventListener('change', () => {
      const parentDiv = select.closest('.f-upsale-main');
      const btn = parentDiv.querySelector('.f-upsale-add');
      btn.setAttribute('data-variant-id', select.value);
    });
  });
}

// Form Submission Handler
document.body.addEventListener("click", async (e) => {
  // Check if the clicked element is a .add-to-cart button
  const btn = e.target.closest('.add-to-cart');
  if (!btn) return; // Exit if the click is not on an .add-to-cart button

  btn.querySelector('svg').classList.remove('hidden2');
  btn.classList.add('txt_indent');

  e.preventDefault(); // Prevent default form submission behavior

  const form = btn.closest('form[action="/cart/add"]');
  if (!form) {
    console.error("Form not found for the clicked add-to-cart button.");
    return;
  }

  try {
    // Normal PDP add (not upsell)
    window.addingFromUpsell = false;
    window.upsellToPrune = null;

    // Add the product to the cart
    await fetch('/cart/add.js', { 
      method: "POST", 
      body: new FormData(form) 
    });

    // Update the cart drawer and item count
    await updateCartDrawer();
    await updateCartItemCount();
    btn.querySelector('svg').classList.add('hidden2');
    btn.classList.remove('txt_indent');
    // Open the cart drawer
    openCartDrawer();
  } catch (error) {
    console.error("Error adding item to cart:", error);
  }
});

// Quick Add Button Handler
document.querySelectorAll('.quick-add__submit').forEach((btn) => {
  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    const form = btn.closest('form');
    const loadingSpinner = form.querySelector('.quick-add__submit .loading__spinner');
    const q_btn = form.querySelector('.quick-add__submit .q_btn');

    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
      q_btn.classList.add('hidden');
    }

    if (form && form.action.endsWith('/cart/add')) {
      try {
        // Normal quick add (not upsell)
        window.addingFromUpsell = false;
        window.upsellToPrune = null;

        await fetch('/cart/add.js', { method: "POST", body: new FormData(form) });
        await updateCartDrawer();
        await updateCartItemCount();
        openCartDrawer();
      } catch (error) {
        console.error("Error updating cart:", error);
      }

      if (loadingSpinner) {
        loadingSpinner.classList.add('hidden');
        q_btn.classList.remove('hidden');
      }
    }
  });
});

// Cart Icon Handler
document.querySelectorAll('.js-drawer-open-cart').forEach(a => {
  a.addEventListener('click', async (e) => {
    console.log("icon click");
    e.preventDefault();
    await updateCartDrawer();
    openCartDrawer();
    await updateCartItemCount();
  });
});

// Initialize Listeners on Page Load
addCartDrawerListeners();
removeCartDrawerListeners();
addCartUpsellListeners();

$(function() {
  $('body').on('click', '.f-cart-drawer-header-right-close', function () {
    closeCartDrawer();
  });

  $('body').on('change', '.variant_selector_cart', function () {
    let varID = $(this).val();
    let parentELe = $(this).closest('.var_btn');
    $(this).find('option').each(function () {
      if ($(this).attr('value') == varID) {
        let salePrice = $(this).attr('data-price');
        let comparePrice = $(this).attr('data-compare-price');
        if (salePrice) {
          parentELe.siblings('.price-section').find('.actual-price').html(salePrice);
        }
        if (comparePrice) {
          parentELe.siblings('.price-section').find('.discount-price').html(comparePrice);
        }
      }
    });
  });

  $('body').on('change', '.variant_selector_cart_list', function () {
    let varID = $(this).val();
    let $this = $(this);
    $(this).find('option').each(function () {
      if ($(this).attr('value') == varID) {
        let salePrice = $(this).attr('data-price');
        let comparePrice = $(this).attr('data-compare-price');
        if (salePrice) {
          $this.siblings('.price-section').find('.actual-price').html(salePrice);
        }
        if (comparePrice) {
          $this.siblings('.price-section').find('.discount-price').html(comparePrice);
        }
      }
    });
  });

  // Handle variant selection in carousel upsells
  $('body').on('change', '.variant_selector_carousel', function () {
    let varID = $(this).val();
    let $item = $(this).closest('.upsell-carousel-item');
    let $button = $item.find('.upsell-add-btn');
    
    // Update button variant ID for our JS listener
    $button.attr('data-variant-id', varID);

    // ==========================
    // FIX: DO NOT set inline onclick anymore (prevents double-add)
    // was: $button.attr('onclick', 'addUpsellToCart(' + varID + ')');
    // ==========================

    // Update price display
    $(this).find('option').each(function () {
      if ($(this).attr('value') == varID) {
        let salePrice = $(this).attr('data-price');
        let comparePrice = $(this).attr('data-compare-price');
        let $priceSection = $item.find('.upsell-item-price');
        
        if (comparePrice && comparePrice !== 'null' && comparePrice !== '') {
          $priceSection.html('<span style="text-decoration: line-through; color: #999; margin-right: 4px;">' + comparePrice + '</span>' + salePrice);
        } else {
          $priceSection.html(salePrice);
        }
      }
    });
  });

  $('html').on('click', '.xsell-quick-add-to-cart', function () {
    setTimeout(() => {
      updateCartDrawer();
      updateCartItemCount();
    }, 2000);
  });
});
